// What goes on paper, chosen above the sheet and never printed: the list's columns (a
// PHONE column starts unticked — a guest list is handed to people), the note, and an empty
// ✓ column for ticking names off at the door. Remembered per list in this browser only;
// a lost or blocked storage just means the defaults.
import { useEffect, useState } from 'react';
import he from '../../i18n/he';
import { groupingOf } from '../../components/lists/listGroups';

const L = he.lists;
const key = (listId) => `pressbooks.listPrint.${listId}`;

const defaults = (list) => ({
  columns: list.columns.filter((c) => c.kind !== 'phone').map((c) => c.id),
  note: true,
  check: false,
});

const read = (list) => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(key(list.id)));
    if (!saved || !Array.isArray(saved.columns)) return defaults(list);
    const ids = new Set(list.columns.map((c) => c.id));
    return { columns: saved.columns.filter((id) => ids.has(id)), note: !!saved.note, check: !!saved.check };
  } catch {
    return defaults(list);
  }
};

export function usePrintChoice(list) {
  const [choice, setChoice] = useState(null);
  useEffect(() => { if (list && !choice) setChoice(read(list)); }, [list, choice]);
  const update = (next) => {
    setChoice(next);
    try { window.localStorage.setItem(key(list.id), JSON.stringify(next)); } catch { /* not remembered */ }
  };
  return [choice, update];
}

export default function PrintOptions({ list, choice, onChoice, children }) {
  const toggleColumn = (id) => onChoice({
    ...choice,
    columns: choice.columns.includes(id) ? choice.columns.filter((x) => x !== id) : [...choice.columns, id],
  });
  return (
    <div className="print-opts">
      <span className="print-opts-label">{L.printColumns}</span>
      {/* The grouping column is printed as the groups' headings, not offered as a column. */}
      {list.columns.filter((c) => c.id !== groupingOf(list).column?.id).map((c) => (
        <label key={c.id} className="print-opt">
          <input type="checkbox" checked={choice.columns.includes(c.id)} onChange={() => toggleColumn(c.id)} />
          {c.label}
        </label>
      ))}
      <label className="print-opt">
        <input type="checkbox" checked={choice.note} onChange={() => onChoice({ ...choice, note: !choice.note })} />
        {L.note}
      </label>
      <label className="print-opt">
        <input type="checkbox" checked={choice.check} onChange={() => onChoice({ ...choice, check: !choice.check })} />
        {L.printCheck}
      </label>
      <span className="print-opts-actions">{children}</span>
    </div>
  );
}
